export default {
  INIT: 'MERCHANT/INIT',
  UPDATE_DATA: 'MERCHANT/UPDATE_DATA',
  UPDATE_META: 'MERCHANT/UPDATE_META',
  UPDATE_PARAMS: 'MERCHANT/UPDATE_PARAMS',
  RESET_DATA: 'MERCHANT/RESET_DATA',
}
